module.exports = __webpack_public_path__ + "static/media/icon-risk-score.ef9495a8.svg";